// extracted by mini-css-extract-plugin
export default {"coming-soon-badge":"ComingSoonBadge_coming-soon-badge__wYCwT","animation":"ComingSoonBadge_animation__GB3b4"};